export const VOUCHER_ENTITY_CARD_TEST_IDS = {
    CARD: "voucher-entity-card",
    IMAGE: "voucher-entity-card-image",
    TITLE: "voucher-entity-card-title",
    META: "voucher-entity-card-meta",
    RATING: "voucher-entity-card-rating",
    RATING_ICON: "voucher-entity-card-rating-icon",
    META_SEPARATOR: "voucher-entity-card-meta-separator",
    SUBTITLE: "voucher-entity-card-subtitle",
    CHEVRON: "voucher-entity-card-chevron",
};
